import classNames from 'classnames';
import React from 'react';
import {useShallow} from 'zustand/react/shallow';

import {TRANSITION_DURATION_CLASSNAME} from '../transitions';
import {useStudentHomepageStore} from '../useStudentHomepageStore';

export default function SidebarWrapperMobile({children}: PropsWithChildrenRequired) {
  'use memo';

  const {isSidebarExpanded, setIsSidebarExpanded} = useStudentHomepageStore(
    useShallow((state) => ({
      isSidebarExpanded: state.isSidebarExpanded,
      setIsSidebarExpanded: state.setIsSidebarExpanded
    }))
  );

  return (
    <>
      <div
        aria-hidden={!isSidebarExpanded}
        className={classNames(
          TRANSITION_DURATION_CLASSNAME,
          'fixed! top-x0 left-x0 z-10 h-screen w-screen overlay-70 transition-opacity m:hidden',
          {
            'cursor-pointer opacity-100': isSidebarExpanded,
            'pointer-events-none opacity-0': !isSidebarExpanded
          }
        )}
        onClick={() => {
          setIsSidebarExpanded(false);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            setIsSidebarExpanded(false);
          }
        }}
        tabIndex={0}
      />
      <div
        className={classNames(
          TRANSITION_DURATION_CLASSNAME,
          'fixed! top-[60px] left-x0 z-20 h-[calc(100vh-60px)] max-w-[60vw] overflow-scroll rounded-r-x2 background-subtle px-x4 py-x3 transition-transform xs:max-w-[50vw] s:max-w-[35vw] m:hidden',
          {
            '-translate-x-full': !isSidebarExpanded
          }
        )}
      >
        {children}
      </div>
    </>
  );
}
